import React, {memo, useState} from "react";
import {connect, useDispatch} from "react-redux";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {Loading} from '../index'
import {LOGOUT} from "../../types";
import Api from "../../utils/api";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const Logout = memo((props) => {


    const { open, onClose } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();



    const [loading, setLoading] = useState(false);


    const handleLogout = () =>
    {

        setLoading(true);

        new Api().get('/auth/logout').then((response) => {
            if (typeof response != "undefined") {
                if (response.status) {
                    dispatch({type: LOGOUT});
                }
            }

            setTimeout(() => {
                navigate('/');
            }, 1000)
        });
    }


    return (
        <Dialog
            fullWidth={true}
            open={open}
            keepMounted
            onClose={() => onClose()}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">آیا برای خروج مطمئن هستید؟</DialogTitle>
            <DialogContent>
                {loading && <Loading />}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color="primary">
                    خیر
                </Button>
                <Button onClick={handleLogout} color="primary">
                    بله خارج میشوم
                </Button>
            </DialogActions>
        </Dialog>
    );

})


const mapStateToProps = state => ({
    authReducer: state.authReducer
});




export default connect(mapStateToProps)(Logout)